import { Box } from '@material-ui/core';

import { SText } from '@setvi/shared/components';
import { pluralize } from '@setvi/shared/utils';

interface CartSummaryProps {
  count: number;
  totalPages: number;
}

export const CartSummary = ({ count, totalPages }: CartSummaryProps) => (
  <Box mt={2} display="flex" alignItems="center" justifyContent="space-between">
    <SText
      title={`${pluralize(count, 'item')} · ${totalPages} pages total`}
      size="sm"
      fontColor="#5D7083"
    />
  </Box>
);
